export const columnSchema = [
  { width: 120, field: 'channel', displayName: 'Channel', type: 'string' },
  { width: 135, field: 'stage', displayName: 'Stage', type: 'string' },
  { width: 145, field: 'requestType', displayName: 'Request Type', type: 'string' },
  { width: 135, field: 'name', displayName: 'Name', type: 'string', tooltip: 'Initially Imported Name' },
  { width: 95, field: 'importedBy', displayName: 'Created By', type: 'string' },
  { width: 120, field: 'createdOn', displayName: 'Imported On', type: 'datetime' },
  { width: 65, field: 'importCount', displayName: 'Imported', type: 'number', tooltip: 'Imported Task Count' },
  { width: 80, field: 'source', displayName: 'From', type: 'string' },
  { width: 70, field: 'id', displayName: 'Import ID', type: 'number', sortIndex: 0, sortOrder: 'desc' }
];
